module.exports = __webpack_public_path__ + "volum_circle2.png?904ec67fc43381420e3ba3db25bdfb93";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volum_circle2.png
// module id = 694
// module chunks = 0